"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaterialSpecSearchModel = instanceOfMaterialSpecSearchModel;
exports.MaterialSpecSearchModelFromJSON = MaterialSpecSearchModelFromJSON;
exports.MaterialSpecSearchModelFromJSONTyped = MaterialSpecSearchModelFromJSONTyped;
exports.MaterialSpecSearchModelToJSON = MaterialSpecSearchModelToJSON;
exports.MaterialSpecSearchModelToJSONTyped = MaterialSpecSearchModelToJSONTyped;
/**
 * Check if a given object implements the MaterialSpecSearchModel interface.
 */
function instanceOfMaterialSpecSearchModel(value) {
    return true;
}
function MaterialSpecSearchModelFromJSON(json) {
    return MaterialSpecSearchModelFromJSONTyped(json, false);
}
function MaterialSpecSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'mdMaterialNo': json['mdMaterialNo'] == null ? undefined : json['mdMaterialNo'],
        'msMaterialColorNo': json['msMaterialColorNo'] == null ? undefined : json['msMaterialColorNo'],
        'pssSpecName': json['pssSpecName'] == null ? undefined : json['pssSpecName'],
    };
}
function MaterialSpecSearchModelToJSON(json) {
    return MaterialSpecSearchModelToJSONTyped(json, false);
}
function MaterialSpecSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'mdMaterialNo': value['mdMaterialNo'],
        'msMaterialColorNo': value['msMaterialColorNo'],
        'pssSpecName': value['pssSpecName'],
    };
}
